import React, { useEffect } from "react";
import { useLocation, useOutletContext, Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { subMenu } from "../../../Menu";

const Settings = () => {
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();
    const { pathname, hash } = useLocation();

    useEffect(() => { }, [pathname, user]);

    const menuRight = (currentApp && currentMenu) ? user.policy.rights[currentApp][currentMenu.id]["sub_menu"] : null;
    
    const filteredMenu = subMenu.filter(menu => {
        return menu.page === "COMPANY_MENU" && menuRight && menuRight[menu.id]["access"]
    });

    return (
        <div className="min-h-full bg-gray-50">
            {/* Navigation tabs */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <nav className="flex space-x-1 overflow-x-auto">
                        {user &&
                            filteredMenu.map((tab) => {
                                const isActive = pathname.startsWith(tab.to);
                                return (
                                    <div key={tab.to}>
                                        {tab.separator && (
                                            <div className="h-8 w-px bg-gray-300 mx-2"></div>
                                        )}
                                        <Link
                                            onClick={() => {
                                                setCurrentTab(tab);
                                            }}
                                            to={tab.to}
                                            className={`
                                                flex items-center px-4 py-3 text-sm font-medium transition-all duration-200 rounded-lg whitespace-nowrap
                                                ${
                                                    isActive
                                                        ? "bg-app-primary text-white shadow-md"
                                                        : "text-gray-700 hover:bg-gray-100 hover:text-app-primary"
                                                }
                                                group no-underline
                                            `}
                                        >
                                            <svg
                                                className={`shrink-0 mr-3 w-5 h-5 transition-colors ${
                                                    isActive
                                                        ? "text-white"
                                                        : "text-gray-500 group-hover:text-app-primary"
                                                }`}
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d={tab.svg}
                                                />
                                            </svg>
                                            {tab.title}
                                        </Link>
                                    </div>
                                );
                            })}
                    </nav>
                </div>
            </div>

            {/* Contenu */}
            <div>
                <Outlet context={[user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu]} />
            </div>
        </div>
    );
};

export default Settings;
